import { connect } from 'react-redux';

import Partner from '../../components/sider/partner';

export default connect()(Partner);



// WEBPACK FOOTER //
// ./containers/sider/partner.js